import { Autocomplete, TextField, IconButton } from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';
import { MANDATORY_FIRST_STAGE, isStorePrApprovalConfig } from '../../config/constants';

const isMandatoryFirstStage = (stage) =>
  stage?.stageName === MANDATORY_FIRST_STAGE.stageName &&
  stage?.stageRoleName === MANDATORY_FIRST_STAGE.stageRoleName;

export const getMandatoryFirstStageSync = (modalData) => {
  const stages = modalData?.stages || [];
  const hasMandatoryFirst = isMandatoryFirstStage(stages[0]);

  if (isStorePrApprovalConfig(modalData) && !hasMandatoryFirst) {
    return {
      stages: [
        { _id: modalData?.curId || 1, StageNumber: 1, ...MANDATORY_FIRST_STAGE },
        ...stages.map((stage) => ({ ...stage, StageNumber: stage.StageNumber + 1 })),
      ],
      curId: (modalData?.curId || 1) + 1,
    };
  }

  if (!isStorePrApprovalConfig(modalData) && hasMandatoryFirst) {
    return {
      stages: stages
        .slice(1)
        .map((stage, index) => ({ ...stage, StageNumber: index + 1 })),
    };
  }

  return null;
};

export const headerConfig = (allowedRoleList, filters) => {
  const isLockedStage = (mainIndex, data) => {
    const absoluteIndex = (filters?.page - 1) * filters?.limit + mainIndex;
    return absoluteIndex === 0 && isMandatoryFirstStage(data);
  };

  const config = [
    {
      label: 'StageNumber',
      id: 'StageNumber',
    },
    {
      label: 'Stage Name',
      id: 'stageName',
      render: (data, onClick, _, mainIndex) => {
        return (
          <TextField
            label="Stage Name"
            name="stageName"
            value={data?.stageName}
            InputLabelProps={{ shrink: true }}
            fullWidth
            size="small"
            variant="outlined"
            disabled={isLockedStage(mainIndex, data)}
            onChange={(e, val) => {
              onClick(e.target, mainIndex, 'stageName');
            }}
          />
        );
      },
    },
    {
      label: 'Stage Role Name',
      id: 'stageRoleName',
      render: (data, onClick, _, mainIndex) => {
        return (
          <TextField
            label="Stage Role Name"
            name="stageRoleName"
            value={data?.stageRoleName}
            InputLabelProps={{ shrink: true }}
            fullWidth
            size="small"
            variant="outlined"
            disabled={isLockedStage(mainIndex, data)}
            onChange={(e, val) => {
              onClick(e.target, mainIndex, 'stageRoleName');
            }}
          />
        );
      },
    },

    {
      label: 'Role',
      id: 'allowedRole',
      render: (data, onClick, _, mainIndex) => {
        return (
          <Autocomplete
            value={
              (data?.allowedRole || data?.allowedRole === 0)
                ? allowedRoleList.find(
                    (item) =>
                      parseInt(item.value) === parseInt(data?.allowedRole)
                  )
                : null
            }
            onChange={(e, val) => {
              onClick(val, mainIndex, 'allowedRole');
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                label="Allowed Role"
                InputLabelProps={{ shrink: true }}
                sx={{
                  minWidth: 220,
                }}
              />
            )}
            options={allowedRoleList}
          />
        );
      },
    },
    {
      label: 'Role User',
      id: 'user',
      render: (data) => {
        return (
          <>
            {allowedRoleList.find(
              (role) => parseInt(role?.value) === data?.allowedRole
            )?.user || null}
          </>
        );
      },
    },
    {
      label: 'Actions',
      id: 'actions',
      render: (data, onClick, _, mainIndex) => {
        return (
          <>
            <IconButton
              onClick={() => {
                onClick(data, mainIndex, 'deleteStage')
              }}
              disabled={isLockedStage(mainIndex, data)}
              sx={{ p: 0 }}
            >
              <DeleteIcon />
            </IconButton>
          </>
        );
      },
    },
  ];

  return config;
};
